import restUtils from "core/utils/rest";
import {
  AssociatedPartiesHistoryItem,
  AssociatedPartiesItem,
  associatedPartiesHistoryRequestTransformer,
  associatedPartiesRequestTransformer,
} from "./transformers/associatedParty";

export const getAssociatedParties = (
  investorId: string,
  includeAmlResults: boolean = false
): Promise<AssociatedPartiesItem[]> => {
  const url = `hubwise-api/aml/investors/${investorId}/associated-parties?includeAmlResults=${includeAmlResults}`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.rows.map(associatedPartiesRequestTransformer);
  });
};

export const getAssociatedPartyHistory = (
  orgId: string
): Promise<AssociatedPartiesHistoryItem[]> => {
  const url = `hubwise-api/aml/investors/${orgId}/associated-party-history`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.rows.map(associatedPartiesHistoryRequestTransformer);
  });
};
